import type { OHLCV } from '@shared/types/candle'

import { registerIndicator } from '@/indicators/registry'
import type { IndicatorConfig, IndicatorResult } from '@/types/indicator'
import { IndicatorBase } from '@/types/indicator'

const CONFIG: IndicatorConfig = {
  id: 'vwap',
  name: 'Volume Weighted Average Price',
  shortName: 'VWAP',
  category: 'volume',
  overlay: true,
  params: [],
  lines: [{ key: 'vwap', label: 'VWAP', color: '#9c27b0', width: 1 }],
}

class VWAP extends IndicatorBase {
  readonly config = CONFIG

  calculate(candles: OHLCV[], _params: Record<string, number | string | boolean>): IndicatorResult {
    const values: (number | null)[] = new Array<number | null>(candles.length).fill(null)

    let cumTPV = 0 // cumulative (typical_price × volume)
    let cumV = 0 // cumulative volume
    let currentDay = -1

    for (let i = 0; i < candles.length; i++) {
      // Reset at each IST day boundary (timestamps are already IST-shifted)
      const day = Math.floor(candles[i].t / 86400)
      if (day !== currentDay) {
        cumTPV = 0
        cumV = 0
        currentDay = day
      }

      const tp = (candles[i].h + candles[i].l + candles[i].c) / 3
      cumTPV += tp * candles[i].v
      cumV += candles[i].v

      values[i] = cumV > 0 ? cumTPV / cumV : null
    }

    return { lines: [{ key: 'vwap', values }] }
  }
}

registerIndicator(VWAP, CONFIG)
